import React from "react";
import { Box, Typography } from "@mui/material";
import { Images } from "../../../utils/Images";

const getImageSrc = (image) => {
  if (!image || (typeof image === "string" && !image.trim())) {
    return Images.fallBackImageCard;
  }
  if (typeof image === "string" && /^https?:\/\//.test(image)) {
    return image;
  }
  return image;
};
const formatDate = (dateString) => {
  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
  };
  return new Date(dateString).toLocaleDateString("en-US", options);
};
const PostCard = ({ image, title, date, onClick }) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        display: "flex",
        alignItems: "center",
        background: "#fff",
        borderRadius: "10px",
        boxShadow: "0px 8px 24px 0px #1B2E5E1F",
        padding: "12px",
        marginBottom: "16px",
        gap: 2,
        minWidth: 320,
        maxWidth: 420,
        border: "1px solid #DBE0E5",
        cursor: "pointer",
        transition: "transform 0.2s, box-shadow 0.2s",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: "0px 12px 32px 0px #1B2E5E2F",
        },
      }}
    >
      <Box
        component="img"
        src={getImageSrc(image)}
        onError={(e) => {
          e.currentTarget.src = Images.fallBackImageCard;
        }}
        alt={title}
        sx={{
          width: 80,
          height: 74,
          borderRadius: "6px",
          objectFit: "cover",
        }}
      />
      <Box>
        <Typography
          variant="subtitle1"
          fontWeight={600}
          gutterBottom
          sx={{
            fontSize: "14px",
            color: "#1D1D1B",
            lineHeight: 1.2,
            fontWeight: 600,
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "#686866",
            fontSize: "14px",
            mt: "10px",
            fontWeight: 400,
          }}
        >
          {formatDate(date)}
        </Typography>
      </Box>

      
    </Box>
  );
};

export default PostCard;
